import React, { Component } from 'react';
import loadingImg from './images/loadingImg.png';
import './index.css';


export default class Video extends Component {
    state = {
        play: false,//用于控制视频播放的开关，在style中使用
    }

    //实现播放
    playVideo = () => {
        const { videoNode } = this;
        this.setState({ play: true });
        videoNode.load();//必要!不然会导致关闭后再次点击不从头开始播放
    }

    //实现播放完毕自动关闭视频,时间为1秒
    closeVideoAuto = () => {
        setTimeout(() => {
            this.setState({ play: false });
        }, 1000)
    }

    //实现手动关闭视频
    closeVideo = () => {
        const { videoNode } = this;
        videoNode.pause();//必要!不然会导致关闭后仍然在后台播放
        this.setState({ play: false });

    }

    render() {
        const { play } = this.state
        return (
            <div className='video-part'>
                {/* 视频点击前的图片及循环旋转的图案 */}
                <div className='videoImg'>
                    <img src='//dl.gamdream.com/idfe-MonumentValley-website/video.9e5e1f91.png' style={{ display: play ? 'none' : 'block' }} onClick={this.playVideo}></img>
                    <div className='loadingImg'>
                        <img src={loadingImg} style={{ display: play ? 'none' : 'block' }} onClick={this.playVideo} />
                    </div>
                    {/* 视频点击后 */}
                    <div className='video-part-play' style={{ display: play ? 'block' : 'none' }}>
                        {/* 背景的遮盖层 */}
                        <div className='backgroundGray' onClick={this.closeVideo}></div>
                        {/* 播放的视频 */}
                        <video ref={currentNode => this.videoNode = currentNode} id="v2" controls="controls" disablePictureInPicture={true} autoPlay onEnded={this.closeVideoAuto}>
                            <source src='//dl.gamdream.com/idfe-MonumentValley-website/videoLogo.7847ea84.mp4' />
                        </video>
                    </div>
                </div>


            </div>
        )
    }
}

